export const RECEIVE_DELETE_VESSEL = 'RECEIVE_DELETE_VESSEL'
export const RECEIVE_GET_VESSEL = 'RECEIVE_GET_VESSEL'
export const RECEIVE_GET_VESSEL_LIST = 'RECEIVE_GET_VESSEL_LIST'
export const RECEIVE_GET_VESSELS = 'RECEIVE_GET_VESSELS'
export const RECEIVE_PERSIST_VESSEL = 'RECEIVE_PERSIST_VESSEL'
export const REQUEST_DELETE_VESSEL = 'REQUEST_DELETE_VESSEL'
export const REQUEST_GET_VESSEL = 'REQUEST_GET_VESSEL'
export const REQUEST_GET_VESSEL_LIST = 'REQUEST_GET_VESSEL_LIST'
export const REQUEST_GET_VESSELS = 'REQUEST_GET_VESSELS'
export const REQUEST_PERSIST_VESSEL = 'REQUEST_PERSIST_VESSEL'
export const FAILED_DELETE_VESSEL = 'FAILED_DELETE_VESSEL'
export const FAILED_GET_VESSEL = 'FAILED_GET_VESSEL'
export const FAILED_GET_VESSEL_LIST = 'FAILED_GET_VESSEL_LIST'
export const FAILED_GET_VESSELS = 'FAILED_GET_VESSELS'
export const FAILED_PERSIST_VESSEL = 'FAILED_PERSIST_VESSEL'
